import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function TechBadge() {
  const ref = useScrollReveal();

  return (
    <section className="relative z-10 px-6 py-20 md:py-32">
      {/* Top divider */}
      <div className="max-w-xs mx-auto mb-16 md:mb-20 h-px bg-white/[0.06]" />

      <div
        ref={ref as React.RefObject<HTMLDivElement>}
        className="reveal max-w-4xl mx-auto flex flex-col items-center text-center gap-6"
      >
        {/* Label */}
        <span
          className="text-xs font-display font-medium tracking-[0.25em] uppercase text-white/20"
        >
          Technology
        </span>

        {/* React logo + name */}
        <div className="flex items-center gap-5 mt-2">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg"
            alt="React"
            className="w-14 h-14 md:w-16 md:h-16 opacity-60"
            style={{
              animation: 'spin 12s linear infinite',
            }}
          />
          <span
            className="font-display font-bold tracking-tight text-white/50"
            style={{ fontSize: 'clamp(2rem, 4vw, 3.2rem)' }}
          >
            React
          </span>
        </div>

        {/* Description */}
        <p
          className="text-sm sm:text-base text-white/25 max-w-md leading-relaxed mt-2"
          style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
        >
          Every website I build is crafted with React delivering fast load times,
          fluid interactions, and a solid foundation that grows with your business.
        </p>
      </div>

      {/* Bottom divider */}
      <div className="max-w-xs mx-auto mt-16 md:mt-20 h-px bg-white/[0.06]" />

      {/* spin keyframe */}
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
      `}</style>
    </section>
  );
}
